import { FC } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { Button } from '@new/common/ui';
import { teachurKeys, useStartCourseMutation } from '@teachur/http-client';
import { useSingleCourse } from '@new/features/courses/contexts/SingleCourseProvider';
import { getErrorMessage } from '@new/lib';

export const StartCourseContent: FC = () => {
  const queryClient = useQueryClient();
  const { course, setActiveStep } = useSingleCourse();

  const startCourseMutation = useStartCourseMutation({
    onSuccess: (_, courseId) => {
      queryClient.invalidateQueries({ queryKey: teachurKeys.courses.completion(courseId) });
      queryClient.invalidateQueries({ queryKey: teachurKeys.courses.detail(courseId) });
      setActiveStep('self');
    },
    onError: (error: unknown) => {
      toast.error(getErrorMessage(error, 'Failed to start course'));
    },
  });

  if (!course || course.status !== 'notStarted') return null;

  const onClickStartCourse = () => {
    startCourseMutation.mutate(course.id);
  };

  return (
    <Button variant="primary" onClick={onClickStartCourse} disabled={startCourseMutation.isPending}>
      {startCourseMutation.isPending ? 'Starting...' : 'Start Course'}
    </Button>
  );
};
